import React, {Suspense, useContext} from "react";
import {Navigate, Route, Routes} from "react-router-dom";
import {AuthContext} from "@context/AuthContext";
import {Spin} from "antd";
import LoginPage from "@pages/login";
import HomePage from "@pages/home";
import SystemsPage from "@pages/systems";
import TeamPage from "@pages/team";
import {
    ArchiveSingleSystem, CodSingleComponent,
    CompletedSystem,
    CompletedSystems,
    ConcludedSystems,
    NewUpdate,
    PlannedSystems,
    ProgressSystems,
    TeamProfile
} from "@components";
import MozPage from "@pages/moz";
import MobfPage from "@pages/mobf";
import VideoSeminarsPage from "@pages/video-seminars";
import ArchivePage from "@pages/archive";
import CodPage from "@pages/cod";
import MyProfilePage from "@pages/me";
import NotificationPage from "@pages/notification";

const PageRoutes = () => {
    const {currentUser} = useContext(AuthContext)
    const RequireAuth = ({children}) => {
        return currentUser ? children : <Navigate to="/login"/>;
    };
    const antIcon = <Spin size='large' />;

    return (
        <Suspense fallback={<Spin indicator={antIcon} style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}} />}>
            <Routes>
                <Route path='/'>
                    <Route path="login" element={<LoginPage />}/>
                    <Route index element={
                        <RequireAuth>
                            <HomePage/>
                        </RequireAuth>
                    }/>
                    <Route path="team">
                        <Route index element={
                            <RequireAuth>
                                <TeamPage />
                            </RequireAuth>
                        }/>
                        <Route path="profile/:id" element={
                            <RequireAuth>
                                <TeamProfile />
                            </RequireAuth>
                        }/>
                        <Route path="new" element={
                            <RequireAuth>
                                <NewUpdate/>
                            </RequireAuth>
                        }/>
                        <Route path="update/:id" element={
                            <RequireAuth>
                                <NewUpdate/>
                            </RequireAuth>
                        }/>
                    </Route>
                    <Route path="systems">
                        <Route index element={
                            <RequireAuth>
                                <SystemsPage />
                            </RequireAuth>
                        }/>
                        <Route path="progress" element={
                            <RequireAuth>
                                <ProgressSystems />
                            </RequireAuth>
                        } />
                        <Route path="concluded" element={
                            <RequireAuth>
                                <ConcludedSystems />
                            </RequireAuth>
                        } />
                        <Route path="planned" element={
                            <RequireAuth>
                                <PlannedSystems />
                            </RequireAuth>
                        } />
                        <Route path="completed" element={
                            <RequireAuth>
                                <CompletedSystems />
                            </RequireAuth>
                        } />
                        <Route path="completed/:id" element={
                            <RequireAuth>
                                <CompletedSystem />
                            </RequireAuth>
                        } />
                    </Route>
                    <Route path="moz" element={
                        <RequireAuth>
                            <MozPage />
                        </RequireAuth>
                    }/>
                    <Route path="mobf" element={
                        <RequireAuth>
                            <MobfPage />
                        </RequireAuth>
                    }/>
                    <Route path="video-seminars" element={
                        <RequireAuth>
                            <VideoSeminarsPage />
                        </RequireAuth>
                    }/>
                    <Route path="archive" element={
                        <RequireAuth>
                            <ArchivePage />
                        </RequireAuth>
                    }/>
                    <Route path="archive/:id" element={
                        <RequireAuth>
                            <ArchiveSingleSystem />
                        </RequireAuth>
                    } />
                    <Route path="cod" element={
                        <RequireAuth>
                            <CodPage />
                        </RequireAuth>
                    }/>
                    <Route path="cod/:id" element={
                        <RequireAuth>
                            <CodSingleComponent />
                        </RequireAuth>
                    }/>
                    <Route path="me" element={
                        <RequireAuth>
                            <MyProfilePage currentUser={currentUser} />
                        </RequireAuth>
                    }/>
                    <Route path="notification" element={
                        <RequireAuth>
                            <NotificationPage />
                        </RequireAuth>
                    }/>
                </Route>
            </Routes>
        </Suspense>
    )
}

export default PageRoutes;